<template>
  <span
    v-if="!editing"
    :class="{
      'text-success': value[component][index],
      'text-danger': !value[component][index]
    }"
    >{{ humanReadableDate }}</span
  >
  <span v-else>
    <datepicker
      class="datepicker inline"
      bootstrap-styling
      :value="value[component][index]"
      @selected="selected"
    />

    <button
      v-if="helper && helper !== '' && helper !== 'null'"

      @click="show"
      v-on-clickaway="close"

      :id="id"
      class="btn btn-link p-0"

      data-container="body"
      data-toggle="popover"
      data-placement="top"
      :data-content="decodeURI(helper)"
    >
      <i class="fas fa-question-circle"></i>
    </button>
  </span>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import contractInlineContentMixin from '@/Mixins/contractInlineContentMixin';

const moment = require('moment');

export default {
  mixins: [contractInlineContentMixin],

  components: {
    Datepicker,
  },

  data() {
    return {
      date: this.value[this.component][this.index],
    };
  },

  computed: {
    humanReadableDate() {
      if (!this.value[this.component][this.index]) {
        return 'Enter Date';
      }
      return moment(this.value[this.component][this.index]).format('DD MMM YYYY');
    },

    disabledDates() {
      const date = new Date();
      const today = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      return {
        to: today,
      };
    },
  },

  methods: {
    selected(value) {
      const date = moment(value).format('DD MMM YYYY');

      this.$nextTick(() => {
        this.$emit('input', date, this.component, this.index);
      });
    },
  },
};
</script>
